import React, { useRef } from "react";

export const useKeyboardNavigation = (children: React.ReactNode) => {
  const focusedNodeId = useRef("");

  const accordionItemIds = React.Children.map<string, React.ReactElement>(
    children as React.ReactElement,
    (child) => (child.props as { id: string }).id,
  );

  const onKeyDown: React.KeyboardEventHandler = (event) => {
    switch (event.key) {
      case "ArrowUp": {
        const itemIndex = findItemIndex(accordionItemIds, focusedNodeId);

        focusedNodeId.current = !!accordionItemIds[itemIndex - 1]
          ? accordionItemIds[itemIndex - 1]
          : accordionItemIds[accordionItemIds.length - 1];

        focusElement(focusedNodeId);
        break;
      }
      case "ArrowDown": {
        const itemIndex = findItemIndex(accordionItemIds, focusedNodeId);

        focusedNodeId.current = !!accordionItemIds[itemIndex + 1]
          ? accordionItemIds[itemIndex + 1]
          : accordionItemIds[0];

        focusElement(focusedNodeId);
        break;
      }
    }
  };

  return { focusedNodeId, onKeyDown };
};

function findItemIndex(items: string[], focusedNodeId: React.MutableRefObject<string>) {
  return items.findIndex((id) => id === focusedNodeId.current) === -1
    ? 0
    : items.findIndex((id) => id === focusedNodeId.current);
}

function focusElement(focusedNodeId: React.MutableRefObject<string>) {
  document.querySelector<HTMLElement>(`#${focusedNodeId.current} button`).focus();
}
